// RoomSelector.jsx - Oda seçim komponenti
import React from 'react';

const RoomSelector = ({ rooms, selectedRoomId, onSelectRoom, loading }) => {
  if (loading) {
    return (
      <div className="p-6 text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
        <p className="text-gray-200 mt-4">Odalar yükleniyor...</p>
      </div>
    );
  }

  if (!rooms || rooms.length === 0) {
    return (
      <div className="p-6 text-center text-gray-200">
        Henüz oda bulunmuyor.
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <h3 className="text-xl font-semibold text-blue-100 mb-4">
        Oda Seçimi
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {rooms.map((room) => (
          <div
            key={room.roomId}
            onClick={() => onSelectRoom(room.roomId)}
            className={`
              cursor-pointer rounded-lg border-2 transition-all duration-200
              ${selectedRoomId === room.roomId
                ? 'border-blue-500 bg-blue-900/30 shadow-lg shadow-blue-500/20'
                : 'border-gray-700 bg-gray-800/50 hover:border-blue-400'
              }
            `}
          >
            <div className="p-5">
              {/* Oda İsmi */}
              <div className="flex items-center justify-between mb-3">
                <h4 className="text-lg font-bold text-blue-100">
                  {room.shortName || room.name}
                </h4>
                {selectedRoomId === room.roomId && (
                  <svg className="w-6 h-6 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                )}
              </div>

              {/* Açıklama */}
              <p className="text-sm text-gray-300 mb-3 line-clamp-2">
                {room.description}
              </p>

              {/* Ekipman */}
              {room.equipment && room.equipment.length > 0 && (
                <div className="mb-3">
                  <p className="text-xs text-blue-300 font-semibold mb-1">Ekipman:</p>
                  <div className="flex flex-wrap gap-1">
                    {room.equipment.slice(0, 3).map((item, idx) => (
                      <span
                        key={idx}
                        className="text-xs bg-blue-900/50 text-blue-200 px-2 py-0.5 rounded"
                      >
                        {item}
                      </span>
                    ))}
                    {room.equipment.length > 3 && (
                      <span className="text-xs text-gray-300">
                        +{room.equipment.length - 3}
                      </span>
                    )}
                  </div>
                </div>
              )}

              {/* Kapasite */}
              <div className="flex items-center text-xs text-gray-300">
                <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
                Maksimum {room.capacity} kişi
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Seçili Oda Detayı */}
      {selectedRoomId && rooms.find(r => r.roomId === selectedRoomId) && (
        <div className="mt-4 p-4 bg-blue-900/20 border border-blue-700 rounded-lg">
          <p className="text-sm text-blue-200">
            <strong>Seçili Oda:</strong>{' '}
            {rooms.find(r => r.roomId === selectedRoomId).name}
          </p>
        </div>
      )}
    </div>
  );
};

export default RoomSelector;
